/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Hand = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.33337 5.75C9.33337 5.33579 8.99759 5 8.58337 5C8.16916 5 7.83337 5.33579 7.83337 5.75V7.25V12.25V12.75H6.33337V12.25V7.25C6.33337 6.83579 5.99759 6.5 5.58337 6.5C5.16916 6.5 4.83337 6.83579 4.83337 7.25V12.75V17.75C4.83337 19.5449 6.28845 21 8.08337 21H13.0834C15.9829 21 18.3334 18.6495 18.3334 15.75H19.8334C19.8334 19.4779 16.8113 22.5 13.0834 22.5H8.08337C5.46002 22.5 3.33337 20.3734 3.33337 17.75V12.75V7.25C3.33337 6.00736 4.34073 5 5.58337 5C5.87606 5 6.15569 5.05589 6.41218 5.15757C6.67221 4.20235 7.54577 3.5 8.58337 3.5C8.87606 3.5 9.15569 3.55589 9.41218 3.65757C9.67221 2.70235 10.5458 2 11.5834 2C12.621 2 13.4945 2.70235 13.7546 3.65757C14.0111 3.55589 14.2907 3.5 14.5834 3.5C15.826 3.5 16.8334 4.50736 16.8334 5.75V10.4414C17.068 10.3585 17.3204 10.3134 17.5834 10.3134C18.826 10.3134 19.8334 11.3207 19.8334 12.5634V15.75H18.3334V12.5634C18.3334 12.1491 17.9976 11.8134 17.5834 11.8134C17.1692 11.8134 16.8334 12.1491 16.8334 12.5634V12.75V15.7499H16.8205C16.7865 16.301 16.097 16.6175 15.5394 16.5396C14.4117 16.3819 13.5705 17.2472 13.3675 17.9293H11.8333C12.0737 16.3716 13.4202 15.1791 15.0451 15.1791C15.1423 15.1791 15.2384 15.1833 15.3334 15.1917V12.75V12.5634V5.75C15.3334 5.33579 14.9976 5 14.5834 5C14.1692 5 13.8334 5.33579 13.8334 5.75V12.75H12.3334V5.75V4.25C12.3334 3.83579 11.9976 3.5 11.5834 3.5C11.1692 3.5 10.8334 3.83579 10.8334 4.25V5.75V12.25V12.75H9.33337V12.25V5.75Z"
                        fill={color}
                    />
                </svg>
        );
    };
